import { lazy } from 'react';
import { AlertOutlined } from '@ant-design/icons';
import { AppRouter } from '@tools/ui/types';
import { incidentsRoutes } from '../pages/Incidents/routes.incidents';
const prefixPath = '/incident-management';

const IncidentsView = lazy(
  () =>
    import(
      /* webpackChunkName: "IncidentManagementRoutes" */ '../pages/Incidents/IncidentsView'
    )
);

export const incidentManagementRoutes: AppRouter = {
  modules: [
    {
      redirectFrom: [prefixPath, `${prefixPath}/*`]
    },
    {
      name: 'Incident Management',
      path: `${prefixPath}/incidents`,
      icon: AlertOutlined,
      component: IncidentsView,
      pages: incidentsRoutes
    }
  ]
};
